import { call, put, takeEvery } from 'redux-saga/effects';
import { AUTH_USER } from '../../pages/Auth/reducer/constants';
import { logUser } from '../reducers/authSlice';
import { BASE_API_PATH, AUTH } from 'api';
import request from 'utils/request';
import axios from 'axios';

export function* authRequest(action) {
  const { user, pass, setLoading, setFalseData } = action;
  try {
    const reqObj = {
      method: 'post',
      data: {
        email: user,
        password: pass,
      },
    };
    const response = yield call(request, `${BASE_API_PATH}/${AUTH}`, reqObj);
    console.log(response,'res')
    localStorage.setItem('access_token', response.access_token);
    axios.defaults.headers.common[
      'Authorization'
    ] = `OAuth ${response.access_token}`;
    yield put(logUser(response.access_token));
    yield call(setLoading, false);
  } catch (e) {
    console.log(e);
    yield call(setLoading, false);
    yield call(setFalseData, true);
  }
}

export default function* authSaga() {
  yield takeEvery(AUTH_USER, authRequest);
}
